'use client'

import { useEffect, useState } from 'react'
import { getScheduleSlots, type ScheduleDay } from './scheduleSlots'
import type { OperatingHours } from './openStatus'

/**
 * Slots de agendado reactivos para el checkout. Recalcula al montar y cada
 * minuto (los slots ya pasados de hoy van desapareciendo). Devuelve [] si el
 * agendado no está habilitado o no hay horario configurado.
 */
export function useScheduleSlots(
  operatingHours: OperatingHours | null,
  timezone: string | null,
  opts: { enabled: boolean; leadMinutes: number; maxDaysAhead: number },
): ScheduleDay[] {
  const [days, setDays] = useState<ScheduleDay[]>([])
  const { enabled, leadMinutes, maxDaysAhead } = opts

  useEffect(() => {
    if (!enabled) {
      setDays([])
      return
    }
    const tz = timezone || 'America/Chicago'
    const compute = () =>
      setDays(getScheduleSlots(operatingHours, tz, new Date(), { leadMinutes, maxDaysAhead }))
    compute()
    const id = setInterval(compute, 60_000)
    return () => clearInterval(id)
  }, [operatingHours, timezone, enabled, leadMinutes, maxDaysAhead])

  return days
}
